import { jsx as _jsx } from "react/jsx-runtime";
import { SocialButtons } from "@components/button/SocialButtons";
import WidgetWrapper from "@components/wrapper/WidgetWrapper";
const SocialMediaWidget = ({ bottomMargin, topMargin, theme, widgetID, ...rest }) => {
    const widgetProps = { bottomMargin, topMargin, theme };
    const socialButtonProps = {
        emailURL: rest.emailButtonUrl,
        facebookURL: rest.facebookButtonUrl,
        twitterURL: rest.twitterButtonUrl,
        linkedinURL: rest.linkedInUrl
    };
    const hasButtons = Object.values(socialButtonProps).some(Boolean);
    if (!hasButtons) {
        return null;
    }
    return (_jsx(WidgetWrapper, { id: widgetID, ...widgetProps, className: "social-media__widget-container", children: _jsx(SocialButtons, { ...socialButtonProps }) }));
};
export default SocialMediaWidget;
